import * as React from "react";

function SvgExclamation(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={38} height={38} {...props}>
        <path
          data-name="Shape Copy 2"
          d="M19 0a19 19 0 1019 19A19.022 19.022 0 0019 0zm0 26.126a1.189 1.189 0 01-1.187-1.187V8.312A1.189 1.189 0 0119 7.125a1.189 1.189 0 011.187 1.187v16.626A1.189 1.189 0 0119 26.125zm0 4.749a1.187 1.187 0 111.187-1.187A1.189 1.189 0 0119 30.874z"
          fill="#ff9800"
        />
      </svg>
    </span>
  );
}

export default SvgExclamation;
